import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import { useStyles } from "../../theme/appStyles";
import {
  Avatar,
  Collapse,
  Divider,
  Grid,
  ListItemButton,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserImg from "../../Images/user_login_photo.webp";
import { useState } from "react";
import { useThemeContext } from "./ThemeContext";
import Notification from "../../Components/Popup/notification";
import LogoMain from "../../Images/logo_main_black.webp";

import { MdOutlineNotificationsNone } from "react-icons/md";
import { MdDarkMode } from "react-icons/md";
import Profile from "../../Components/Popup/profile";
import { appColors } from "../../theme/appcolors";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CategoryIcon from "@mui/icons-material/Category";
import PeopleIcon from "@mui/icons-material/People";
import LoopIcon from "@mui/icons-material/Loop";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import StyleIcon from "@mui/icons-material/Style";
import FlagIcon from "@mui/icons-material/Flag";
import PrintIcon from "@mui/icons-material/Print";
import PaidIcon from "@mui/icons-material/Paid";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StoreIcon from "@mui/icons-material/Store";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import SettingsIcon from "@mui/icons-material/Settings";
import DescriptionIcon from "@mui/icons-material/Description";
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SettingsApplicationsSharpIcon from '@mui/icons-material/SettingsApplicationsSharp';
import GroupsIcon from '@mui/icons-material/Groups';
import axios from 'axios';
import EventIcon from "@mui/icons-material/Event";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import InsightsIcon from '@mui/icons-material/Insights';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';


const drawerWidth = 280;
const headerHeight = 100;
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}



const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: headerHeight,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    paddingLeft: 0,
  }),
  ...(!open && {
    marginLeft: 0,
    width: "100%",
    paddingLeft: "75px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  }),
}));

const IsNotMobileDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
  }),
}));

const MobileDrawer = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
}));

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: 64,
  padding: "0 20px",
  backgroundColor: "#0d1b2a",
  margin: "0px",
  justifyContent: "space-between",
  flexShrink: 0,
}));

const DrawerContent = styled("div")(({ theme }) => ({
  backgroundColor: "#ffffff",
  overflowY: "auto",
  overflowX: "hidden",
  flexGrow: 1,
  borderRight: "1px solid #f0ebe4",
  paddingTop: 8,
  paddingBottom: 16,
  scrollbarWidth: "none",
  "-ms-overflow-style": "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

const PaddingBody = styled("div")(({ theme }) => ({
  height: headerHeight,
}));

type SubmenuItem = {
  topBarTitle?: string;
  title: string;
  path: string;
  newPage?: boolean;
  icon: React.ReactElement;
};

type menuList = {
  topBarTitle: string;
  title: string;
  icon: React.ReactElement;
  path: string;
  newPage?: boolean;
  submenuOpen?: boolean;
  submenus?: SubmenuItem[];
};

const MainMenuList: {
  comomTitle: string;
  menuList?: menuList[];
}[] = [
  {
    comomTitle: "General",
    menuList: [
      {
        title: "Dashboard",
        topBarTitle: "Welcome!",
        icon: <MenuIcon />,
        path: "/dashboard/list",
        submenuOpen: false,
      },
      {
        title: "Banquet",
        topBarTitle: "Banquet Hall",
        icon: <EventIcon />,
        path: "#",
        submenuOpen: true,
        submenus: [
          {
            title: "Dashboard",
            topBarTitle: "Banquet Dashboard",
            icon: <MenuIcon />,
            path: "/banquet/dashboard",
          },
          {
            title: "Calendar",
            topBarTitle: "Hall Calendar",
            icon: <EventIcon />,
            path: "/banquet/calendar",
          },
          {
            title: "Pricing",
            topBarTitle: "Hall Pricing",
            icon: <PaidIcon />,
            path: "/banquet/pricing",
          },
        ],
      },
      {
        title: "Services",
        topBarTitle: "Services Management",
        icon: <MiscellaneousServicesIcon />,
        path: "#",
        submenuOpen: false,
        submenus: [
          {
            title: "In-House Services",
            topBarTitle: "In-House Services",
            icon: <StoreIcon />,
            path: "/banquet/services",
          },
          {
            title: "Vendor Services",
            topBarTitle: "Vendor Services",
            icon: <StoreIcon />,
            path: "/vendors/services",
          },
          {
            title: "Service Catalogue",
            topBarTitle: "Service Catalogue",
            icon: <StoreIcon />,
            path: "/banquet/service-catalogue",
          },
        ],
      },
      {
        title: "Vendors",
        topBarTitle: "Vendor Management",
        icon: <StoreIcon />,
        path: "#",
        submenuOpen: false,
        submenus: [
          {
            title: "Vendor List",
            topBarTitle: "Vendor Management",
            icon: <StoreIcon />,
            path: "/vendors/list",
          },
          {
            title: "Vendor Intelligence",
            topBarTitle: "Vendor Profit & Intelligence Dashboard",
            icon: <InsightsIcon />,
            path: "/vendors/intelligence",
          },
        ],
      },
      // {
      //   title: "Products",
      //   topBarTitle: "Products",
      //   icon: <ProductionQuantityLimitsIcon />,
      //     path: "#",
      //   submenuOpen: true,
      //   submenus: [
      //   {
      //       title: "Product",
      //       topBarTitle: "Product List",
      //       icon: <ProductionQuantityLimitsIcon />,
      //       path: "/product/list",
      //     },
      //     {
      //       title: "Category",
      //       topBarTitle: "Category List",
      //       icon: <CategoryIcon />,
      //       path: "/category/list",
      //     },
      //     {
      //       topBarTitle: "Looping List",
      //       title: "Looping",
      //       icon: <MenuIcon />,
      //       path: "/looping/list",
      //     },
      //     {
      //       topBarTitle: "Department List",
      //       title: "Department",
      //       icon: <MenuIcon />,
      //       path: "/department/list",
      //     },
      //     {
      //       topBarTitle: "Coursing List",
      //       title: "Coursing",
      //       icon: <MenuIcon />,
      //       path: "/coursing/list",
      //     },
      //     {
      //       topBarTitle: "Product Brand List",
      //       title: "Product Brand",
      //       icon: <MenuIcon />,
      //       path: "/brand/list",
      //     },
      //     {
      //       topBarTitle: "Product Tag List",
      //       title: "Product Tag",
      //       icon: <MenuIcon />,
      //       path: "/tag/list",
      //     },
      //     {
      //       topBarTitle: "Modifier Group",
      //       title: "Modifier Group",
      //       icon: <CategoryIcon />,
      //       path: "/modifierGrp/list",
      //     },
      //   ],
      // },
      //   {
      //   title: "Modifiers",
      //   topBarTitle: "Modifiers",
      //   icon: <PostAddIcon />,
      //     path: "#",
      //   submenuOpen: true,
      //   submenus: [
      //      {
      //       title: "Modifier Category",
      //       topBarTitle: "Modifier Category List",
      //       icon: <CategoryIcon />,
      //       path: "/modifierCategory/list",
      //     },

      //        {
      //             topBarTitle: "Modifier List",
      //             title: "Modifier",
      //             icon: <PostAddIcon />,
      //             path: "/modifier/list",
      //           },
                
      //           {
      //               topBarTitle: "Modifier Group",
      //             title: "Modifier Group",
      //             icon: <DynamicFeedIcon />,
      //             path: "/modifierGroup/list",
      //           },
      //   ],
      // },
      
      // {
      //   title: "Services",
      //   topBarTitle: "Services",
      //   icon: <ProductionQuantityLimitsIcon />,
      //   path: "/product",
      //   submenuOpen: true,
      //   submenus: [
      //     {
      //       topBarTitle: "Services List",
      //       title: "List",
      //       icon: <MenuIcon />,
      //       path: "/product/list",
      //     },
      //     {
      //       topBarTitle: "Create Services",
      //       title: "Create",
      //       icon: <MenuIcon />,
      //       path: "/product/create",
      //     },
      //   ],
      // },
//  {
//         title: "Modifier Group",
//         topBarTitle: "Modifier Group",
//         icon: <CategoryIcon />,
//         path: "/modifierGrp/list",
//         submenuOpen: false,
//       },

  // {
  //       title: "Events1",
  //       topBarTitle: "Events List",
  //       icon: <EventIcon />,
  //       path: "/event/list",
  //       submenuOpen: false,
  //     },
       {
        title: "Events",
        topBarTitle: "Event Product List",
        icon: <EventIcon />,
        path: "/product/event",
        submenuOpen: false,
      },
      {
        title: "Email Hub",
        topBarTitle: "Email Communication Hub",
        icon: <EmailOutlinedIcon />,
        path: "/email-hub",
        submenuOpen: false,
      },
      {
        title: "Lead System",
        topBarTitle: "Lead Management",
        icon: <LeaderboardOutlinedIcon />,
        path: "#",
        submenuOpen: true,
        submenus: [
          {
            title: "Inquiries",
            topBarTitle: "Website Inquiries",
            icon: <ContactPageOutlinedIcon />,
            path: "/leads/inquiries",
          },
          {
            title: "Pipeline",
            topBarTitle: "Lead Pipeline",
            icon: <ViewKanbanOutlinedIcon />,
            path: "/leads/pipeline",
          },
          {
            title: "Calendar",
            topBarTitle: "Lead Calendar",
            icon: <CalendarMonthOutlinedIcon />,
            path: "/leads/calendar",
          },
          {
            title: "Dashboard",
            topBarTitle: "Lead Dashboard",
            icon: <DashboardOutlinedIcon />,
            path: "/leads/dashboard",
          },
        ],
      },

      {
        title: "Inquiry",
        topBarTitle: "Inquiry List",
        icon: <ContactSupportIcon  />,
        path: "#",
        submenuOpen: true,
         submenus: [

           {
           title: "Inquiry",
            topBarTitle: "Inquiry List",
            icon: <ProductionQuantityLimitsIcon />,
            path: "/inquiry/list",
          },
           {
        title: "Calender",
        topBarTitle: "Inquiry List",
        icon: <EventIcon  />,
        path: "/inquiries/list",
      },
    ]
      },

      

      //   {
      //   title: "Scan",
      //   topBarTitle: "",
      //   icon: <EventIcon />,
      //   path: "/scan/list",
      //   submenuOpen: false,
      // },
      
      {
        title: "Quotes",
        topBarTitle: "Quotes List",
        icon: <FormatQuoteIcon />,
        path: "/quote/list",
        submenuOpen: false,
      },
      {
        title: "Invoice",
        topBarTitle: "Invoice List",
        icon: <DescriptionIcon />,
        path: "/invoice/list",
        submenuOpen: false,
      },

      {
        title: "Invoice POS",
        topBarTitle: "Invoice Pos List",
        icon: <DescriptionIcon />,
        path: "/invoicePos/list",
        submenuOpen: false,
      },

       {
        title: "PayOut",
        topBarTitle: "PayOut",
        icon: <PaidIcon />,
        path: "/payouts/list",
        submenuOpen: false,
      },
     
      {
        title: "Expense",
        topBarTitle: "Expense Management",
        icon: <AttachMoneyIcon />,
        path: "/expense/list",
        submenuOpen: false,
      },
 {
        title: "Inventory",
        topBarTitle: "Inventory",
        icon: <ProductionQuantityLimitsIcon />,
          path: "#",
        submenuOpen: true,
        submenus: [
        {
            title: "Inventory",
            topBarTitle: "Inventory List",
            icon: <ProductionQuantityLimitsIcon />,
            path: "/inventory/list",
          },
          {
            topBarTitle: "vendor List",
            title: "Vendor",
            icon: <MenuIcon />,
            path: "/vendor/list",
          },
                 {
        title: "Bills",
        topBarTitle: "Bill List",
        icon: <DescriptionIcon />,
        path: "/bill/list",
       
      },
        
        
        
        ],
      },

      
      
      {
        title: "Clients",
        topBarTitle: "Customer List",
        icon: <PeopleIcon />,
        path: "/customer/list",
        submenuOpen: false,
      },

      {
        title: "Reports",
        topBarTitle: "Reports",
        icon: <DescriptionIcon />,
        path: "/report/list",
        submenuOpen: false,
      },
      
      // {
      //   title: "Invoice",
      //   topBarTitle: "Invoice",
      //   icon: <DescriptionIcon />,
      //   path: "/invoice",
      //   submenuOpen: true,
      //   submenus: [
      //     {
      //       topBarTitle: "Invoice List",
      //       title: "List",
      //       icon: <MenuIcon />,
      //       path: "/
      //     },
      //   ],
      // },
    ],
  },
  {
    comomTitle: "Users",
    menuList: [
      // {
      //   title: "Company",
      //   topBarTitle: "Company",
      //   icon: <StoreIcon />,
      //   path: "/company",
      //   submenuOpen: true,
      //   submenus: [
      //     {
      //       topBarTitle: "Company List",
      //       title: "List",
      //       icon: <PeopleIcon />,
      //       path: "/company/list",
      //     },
      //     {
      //       topBarTitle: "Create Company",
      //       title: "Create",
      //       icon: <MenuIcon />,
      //       path: "/company/create",
      //     },
      //   ],
      // },
      {
        title: "Company",
        topBarTitle: "Company List",
        icon: <StoreIcon />,
        path: "/company/list",
        submenuOpen: false,
      },
    
      {
        title: "User",
        topBarTitle: "User List",
        icon: <GroupsIcon />,
        path: "/team/list",
        submenuOpen: false,
      },

     
      // {
      //   title: "Team",
      //   topBarTitle: "Team",
      //   icon: <GroupsIcon />,
      //   path: "/team",
      //   submenuOpen: true,
      //   submenus: [
      //     {
      //       topBarTitle: "Team List",
      //       title: "List",
      //       icon: <PeopleIcon />,
      //       path: "/team/list",
      //     },
      //     {
      //       topBarTitle: "Create Team",
      //       title: "Create",
      //       icon: <MenuIcon />,
      //       path: "/team/create",
      //     },
      //   ],
      // },
    ],
  },
  {
    comomTitle: "Settings",
    menuList: [
      {
        title: "Settings",
        topBarTitle: "Settings",
        icon: <SettingsApplicationsSharpIcon />,
         path: "#",
        submenuOpen: true,
        submenus: [


          {
            topBarTitle: "Tax List",
            title: "Tax",
            icon: <PeopleIcon />,
            path: "/tax/list",
          },
          {
            topBarTitle: "Printer List",
            title: "Printer",
            icon: <PeopleIcon />,
            path: "/printer/list",
          },
          {
            topBarTitle: "Email Template List",
            title: "Email",
            icon: <PeopleIcon />,
            path: "/email/list",
          },
          {
            topBarTitle: "Note Template List",
            title: "Note",
            icon: <PeopleIcon />,
            path: "/note/list",
          },

        ],
      },

    ],
  },
];

export default function MiniDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(true);
  const isSalesRoute = location.pathname.startsWith('/sales');
  const isScanRoute = location.pathname.startsWith('/scan');

  const [notificationPopUp, setNotificationPopUp] =
    React.useState<HTMLElement | null>(null);
  const { mode, toggleTheme } = useThemeContext();
  const [profilePopUp, setProfilePopUp] = useState<HTMLElement | null>(null);
  const openProfilePopUp = Boolean(profilePopUp);
  const openNotificationPopUp = Boolean(notificationPopUp);

  const [currentMenuName, setCurrentMenuName] = React.useState("");
  const [hoveredMenuName, setHoveredMenuName] = React.useState("");
  const [expandMenu, setExpandMenu] = React.useState<string>("");
  const [topBarTitle, setTopBarTitle] = useState("");
  const [hoveredSubmenu, setHoveredSubmenu] = React.useState("");
  const [selectedSubmenu, setSelectedSubmenu] = React.useState("");

  interface UserInfo {
    id: number;
    username: string;
    token: string;
    user_id: number;
    role?: string;
  }
  
  
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const API_URL = process.env.REACT_APP_API_URL;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentMenuName]);

  React.useEffect(() => {
    let found = false;
    for (const mainMenu of MainMenuList) {
      for (const menu of mainMenu.menuList || []) {
        if (menu.path === location.pathname) {
          setCurrentMenuName(menu.path);
          setSelectedSubmenu("");
          setExpandMenu(menu.title);
          found = true;
        }

        for (const submenu of menu.submenus || []) {
          if (submenu.path === location.pathname) {
            setSelectedSubmenu(submenu.path);
            setExpandMenu(menu.title);
            setHoveredSubmenu(submenu.path);
            found = true;
          }
        }

        if (found) break;
      }
      if (found) break;
    }
  }, [location.pathname]);

  React.useEffect(() => {
    const findTopBarTitle = (): string => {
      // Check custom routes first
      if (location.pathname.startsWith("/customer-history/")) {
        return "Customer Details";
      }
      if (location.pathname.startsWith("/product-history/")) {
        return "Product Details";
      }
      if (location.pathname.startsWith("/company-history/")) {
        return "Company Details & Edit";
      }
      if (location.pathname.startsWith("/quote-history/")) {
        return "Work Order Edit";
      }
      if (location.pathname.startsWith("/work-order/history/")) {
        return "Work Order Details";
      }
      if (location.pathname.startsWith("/invoice/history/")) {
        return "Invoice Details";
      }
      if (location.pathname.startsWith("/team-history/")) {
        return "Team Details";
      }
      if (location.pathname.startsWith("/customer-history/project/")) {
        return "Customer's Project Details";
      }
        if (location.pathname.startsWith("/customer-history/inquiry/")) {
        return "Customer's Inquiry Details";
      }

      if (location.pathname.startsWith("/looping/create")) {
        return "Create Looping";
      }
      if (location.pathname.startsWith("/department/create")) {
        return "Create Department";
      }
      if (location.pathname.startsWith("/coursing/create")) {
        return "Create Coursing";
      }
      if (location.pathname.startsWith("/brand/create")) {
        return "Create Product Brand";
      }
      if (location.pathname.startsWith("/tag/create")) {
        return "Create Product Tag";
      }
      if (location.pathname.startsWith("/tax/create")) {
        return "Create Tax";
      }
      if (location.pathname.startsWith("/printer/create")) {
        return "Create Printer";
      }
      if (location.pathname.startsWith("/customer/create")) {
        return "Create Customer";
      }
      if (location.pathname.startsWith("/email/create")) {
        return "Create Email Template";
      }
      if (location.pathname.startsWith("/note/create")) {
        return "Create Note Template";
      }
      if (location.pathname.startsWith("/banquet/booking/create")) {
        return "New Banquet Booking";
      }
      if (location.pathname.startsWith("/banquet/booking/")) {
        return "Booking Details";
      }

      // Check MainMenuList for matching path
      for (const mainMenu of MainMenuList) {
        for (const menu of mainMenu.menuList || []) {
          if (menu.path === location.pathname) {
            return menu.topBarTitle;
          }

          for (const submenu of menu.submenus || []) {
            if (submenu.path === location.pathname) {
              return submenu.topBarTitle || "WELCOME!";
            }
          }
        }
      }

      // Default title if no matches are found
      // return "WELCOME!";
      return "";
    };

    setTopBarTitle(findTopBarTitle());
  }, [location.pathname]);

  
  React.useEffect(() => {
    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
        
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };
  
   
    fetchUserInfo();
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
    setExpandMenu("");
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  const handleClickNotificationPopUp = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setNotificationPopUp(event.currentTarget);
  };

  const handleClickProfilePopUp = (event: React.MouseEvent<HTMLElement>) => {
    setProfilePopUp(event.currentTarget);
  };

  const handleCloseProfilePopUp = () => {
    setProfilePopUp(null);
  };

  const handleCloseNotificationPopUp = () => {
    setNotificationPopUp(null);
  };

  const handleImgClick = () => {
    navigate("/expense/list");
  };

  const handleMainMenuItemClick = (ml: menuList) => {
    if (ml.submenus && ml.submenus.length > 0) {
      setExpandMenu(ml.title === expandMenu ? "" : ml.title);
    } else if (ml.path) {
      setCurrentMenuName(ml.path);
      setSelectedSubmenu("");
      navigate(ml.path);
      setMobileDrawerOpen(false);
    }
    setTopBarTitle(ml.topBarTitle || "WELCOME!");
  };

  const handleSubmenuItemClicked = (submenu: SubmenuItem) => {
    setCurrentMenuName(submenu.path);
    setSelectedSubmenu(submenu.path);
    navigate(submenu.path);
    setTopBarTitle(submenu.topBarTitle || "WELCOME!");
    setMobileDrawerOpen(false);
  };





const filteredMainMenuList = React.useMemo(() => {
  if (!userInfo?.role) return MainMenuList;

  const restrictedRoles = ["Staff", "Coordinator"];
  const allowedMenus = ["Dashboard", "Events", "Banquet", "Services", "Vendors", "Email Hub", "Lead System"];
  

  if (restrictedRoles.includes(userInfo.role)) {
    return MainMenuList
      .map((section) => {
        const filteredMenus = section.menuList?.filter((menu) =>
          allowedMenus.includes(menu.title)
        );

        return filteredMenus && filteredMenus.length > 0
          ? { ...section, menuList: filteredMenus }
          : null;
      })
      .filter(
        (section): section is { comomTitle: string; menuList: menuList[] } =>
          section !== null
      );
  }

  return MainMenuList;
}, [userInfo]);


  if (!userInfo) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }


  return (
    <Box sx={{ display: "flex" }}>
      {!isMobile ? (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar position="fixed" open={open} 
           className={isSalesRoute || isScanRoute ? classes.SalesTopbar : classes.topbar}
            style={{ width: "100%", marginLeft: 0 }} >
          {(isSalesRoute || isScanRoute)  && (
    <img
      src={LogoMain}
      alt="AttoDesk Logo"
      
      style={{
        position: "absolute",
        left: "40px", // adjust as needed
        top: "50%",
        transform: "translateY(-50%)",
        height: "40px", // or whatever fits your AppBar
        cursor: "pointer",
      }}
      onClick={handleImgClick}
    />
  )}
            <Toolbar className={classes.toolbar}>
              <Typography width={"100%"} className={classes.h4}>
                {topBarTitle}
              </Typography>

            
              <Grid
                container
                data-testid="user-content"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >

<Grid item>
            <Link to="/dashboard/list" style={{ textDecoration: 'none' }}>
    <Typography variant="h6" sx={{ cursor: 'pointer', color: 'primary.main' }}>
      Admin
    </Typography>
  </Link>
  </Grid>
            <Grid item>
  <Link to="/sales" style={{ textDecoration: 'none' }}>
    <Typography variant="h6" sx={{ cursor: 'pointer', color: 'primary.main' }}>
      Sales
    </Typography>
  </Link>
              </Grid>

               <Grid item>
  <Link to="/payments" style={{ textDecoration: 'none' }}>
    <Typography variant="h6" sx={{ cursor: 'pointer', color: 'primary.main' }}>
      Payments
    </Typography>
  </Link>
              </Grid>
                <Grid item>
               
                  <IconButton
                    onClick={handleClickNotificationPopUp}
                    className={classes.topbarButton}
                    aria-haspopup="true"
                  >
                    <MdOutlineNotificationsNone
                      className={classes.topbarIcon}
                    />
                  </IconButton>
                  <IconButton
                    onClick={toggleTheme}
                    aria-haspopup="true"
                    className={classes.topbarButton}
                  >
                    {mode == "light" ? (
                      <MdDarkMode className={classes.topbarIcon} />
                    ) : (
                      <MdDarkMode className={classes.topbarIcon} />
                    )}
                  </IconButton>
                  <IconButton
                    onClick={handleClickProfilePopUp}
                    className={classes.topbarButton}
                    aria-haspopup="true"
                  >
                    <Avatar
                      alt="Travis Howard"
                      src={UserImg}
                      className={classes.topbarIconProfile}
                    />
                  </IconButton>
                 
                </Grid>

               

                <Grid item>
                  <div className={classes.appSearch}>
                    <Typography width={"100%"} className={classes.h5}>
                      {userInfo?.username}
                    </Typography>
                    <span style={{ fontSize: "0.8rem", color: "#888" }}>
                      {userInfo?.role}
                    </span>
                  </div>
                </Grid>
              </Grid>
             

              <Profile
                profile={profilePopUp}
                onClose={handleCloseProfilePopUp}
                open={openProfilePopUp}
              />
              <Notification
                notification={notificationPopUp}
                onClose={handleCloseNotificationPopUp}
                open={openNotificationPopUp}
              />
            </Toolbar>
          </AppBar>
          {(!isSalesRoute && !isScanRoute) && (
          <IsNotMobileDrawer variant="permanent" open={open}>
            <DrawerHeader>
              {open ? (
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1.2, cursor: "pointer", minWidth: 0 }}
                  onClick={handleImgClick}
                >
                  <Box sx={{
                    width: 32, height: 32, borderRadius: "8px",
                    background: "linear-gradient(135deg, #c9a96e, #a07840)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#0d1b2a", lineHeight: 1 }}>D</Typography>
                  </Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: "#ffffff", lineHeight: 1.2, whiteSpace: "nowrap" }}>
                      Durham CC
                    </Typography>
                    <Typography sx={{ fontSize: 9, color: "#c9a96e", letterSpacing: "0.08em", textTransform: "uppercase", lineHeight: 1.2 }}>
                      Banquet System
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box
                  onClick={handleImgClick}
                  sx={{
                    width: 32, height: 32, borderRadius: "8px",
                    background: "linear-gradient(135deg, #c9a96e, #a07840)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    cursor: "pointer", mx: "auto",
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#0d1b2a", lineHeight: 1 }}>D</Typography>
                </Box>
              )}
              <IconButton
                onClick={handleDrawerToggle}
                size="small"
                sx={{
                  color: "rgba(255,255,255,0.4)",
                  borderRadius: "6px",
                  width: 28, height: 28,
                  "&:hover": { color: "#c9a96e", bgcolor: "rgba(255,255,255,0.08)" },
                }}
              >
                {open ? (
                  <ChevronLeftIcon sx={{ fontSize: 16 }} />
                ) : (
                  <ChevronRightIcon sx={{ fontSize: 16 }} />
                )}
              </IconButton>
            </DrawerHeader>

            <DrawerContent>
              {filteredMainMenuList.map((ml, index) => {
                const isActive = (path: string) =>
                  selectedSubmenu?.startsWith(path) || currentMenuName === path;

                return (
                <React.Fragment key={index}>
                  {/* Section divider */}
                  {index > 0 && open && (
                    <Box sx={{ mx: 2, my: 1.2 }}>
                      <Divider sx={{ borderColor: "#f0ebe4" }} />
                    </Box>
                  )}

                  {/* Section label */}
                  {open && (
                    <Typography sx={{
                      fontSize: 10, fontWeight: 700, color: "#a8977e", letterSpacing: "0.1em",
                      textTransform: "uppercase", px: 2.5, pt: index === 0 ? 1 : 0.5, pb: 0.5,
                    }}>
                      {ml.comomTitle}
                    </Typography>
                  )}

                  {ml.menuList && (
                    <List sx={{ px: 1, py: 0 }}>
                      {ml.menuList.map((menuList) => {
                        const active = isActive(menuList.path);

                        return (
                        <ListItem
                          button
                          key={menuList.title}
                          disablePadding
                          sx={{ display: "block", mb: "2px" }}
                          onMouseEnter={() => setHoveredMenuName(menuList.path)}
                          onMouseLeave={() => setHoveredMenuName("")}
                        >
                          <ListItemButton
                            component={Link} to={menuList.path}
                            onClick={() => handleMainMenuItemClick(menuList)}
                            sx={{
                              borderRadius: "8px",
                              mx: 0.5,
                              py: "7px",
                              px: 1.5,
                              transition: "all 0.15s ease",
                              backgroundColor: active ? "#ffebd3" : "transparent",
                              "&:hover": {
                                backgroundColor: active ? "#ffebd3" : "#fef6ee",
                                "& .menu-icon-wrap": { bgcolor: active ? "#c9a96e" : "#f0ebe4", color: active ? "#0d1b2a" : "#5c6b7e" },
                              },
                              "& .MuiTypography-root": {
                                color: active ? "#0d1b2a" : "#5c6b7e",
                                fontWeight: active ? 600 : 500,
                                fontSize: "0.825rem",
                                transition: "color 0.15s",
                              },
                            }}
                          >
                            {/* Icon with circle wrap */}
                            <Box
                              className="menu-icon-wrap"
                              sx={{
                                width: 30, height: 30, borderRadius: "8px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                mr: open ? 1.2 : 0,
                                bgcolor: active ? "#c9a96e" : "transparent",
                                color: active ? "#0d1b2a" : "#8a97a6",
                                transition: "all 0.15s ease",
                                flexShrink: 0,
                                "& .MuiSvgIcon-root": { fontSize: 18 },
                              }}
                            >
                              {menuList.icon as React.ReactNode}
                            </Box>
                            {open && <ListItemText sx={{ m: 0 }}>{menuList.title}</ListItemText>}
                            {open && menuList.submenus && (
                              <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
                                {expandMenu === menuList.title ? (
                                  <ExpandLessIcon sx={{ fontSize: 16, color: active ? "#0d1b2a" : "#a8977e" }} />
                                ) : (
                                  <ExpandMoreIcon sx={{ fontSize: 16, color: active ? "#0d1b2a" : "#a8977e" }} />
                                )}
                              </Box>
                            )}
                          </ListItemButton>

                          {/* Submenu */}
                          {menuList.submenus && open && (
                            <Collapse in={expandMenu === menuList.title} timeout="auto" unmountOnExit>
                              <List sx={{ pl: 2, pr: 0.5, py: 0, mt: "2px" }}>
                                {menuList.submenus.map((submenu) => {
                                  const subActive = selectedSubmenu === submenu.path;
                                  return (
                                  <ListItem
                                    disablePadding
                                    key={submenu.title}
                                    onMouseEnter={() => setHoveredSubmenu(submenu.path)}
                                    onMouseLeave={() => setHoveredSubmenu("")}
                                  >
                                    <ListItemButton
                                      component={Link} to={submenu.path}
                                      onClick={() => handleSubmenuItemClicked(submenu)}
                                      sx={{
                                        borderRadius: "8px",
                                        py: "5px",
                                        pl: 2.5,
                                        pr: 1,
                                        mb: "1px",
                                        transition: "all 0.12s ease",
                                        position: "relative",
                                        backgroundColor: subActive ? "#ffebd3" : "transparent",
                                        "&:hover": { backgroundColor: subActive ? "#ffebd3" : "#fef6ee" },
                                        "&::before": {
                                          content: '""',
                                          position: "absolute",
                                          left: 10,
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          width: 5, height: 5,
                                          borderRadius: "50%",
                                          bgcolor: subActive ? "#c9a96e" : "#d4cdc2",
                                          transition: "background-color 0.15s",
                                        },
                                        "& .MuiTypography-root": {
                                          fontSize: "0.8rem",
                                          color: subActive ? "#0d1b2a" : "#8a97a6",
                                          fontWeight: subActive ? 600 : 400,
                                          transition: "color 0.15s",
                                        },
                                      }}
                                    >
                                      <ListItemText>{submenu.title}</ListItemText>
                                    </ListItemButton>
                                  </ListItem>
                                  );
                                })}
                              </List>
                            </Collapse>
                          )}
                        </ListItem>
                        );
                      })}
                    </List>
                  )}
                </React.Fragment>
                );
              })}

              {/* ── User profile footer ── */}
              {open && userInfo && (
                <Box sx={{
                  mt: "auto", mx: 1.5, mb: 1, p: 1.5,
                  borderRadius: "10px", bgcolor: "#faf8f4",
                  border: "1px solid #f0ebe4",
                  display: "flex", alignItems: "center", gap: 1.2,
                }}>
                  <Avatar
                    alt={userInfo.username}
                    src={UserImg}
                    sx={{ width: 32, height: 32, border: "1.5px solid #c9a96e" }}
                  />
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#0d1b2a", lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {userInfo.username}
                    </Typography>
                    <Typography sx={{ fontSize: 10, color: "#a8977e", lineHeight: 1.2 }}>
                      {userInfo.role || "Staff"}
                    </Typography>
                  </Box>
                </Box>
              )}
            </DrawerContent>
          </IsNotMobileDrawer>
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex" }}>
          <AppBar position="fixed" className={classes.mobileTopbar}>
            <Toolbar className={classes.toolbar}>
              <Grid
                container
                justifyContent="space-between"
                sx={{ width: "100%" }}
                alignItems="center"
              >
                <Grid item md={1} sm={1}>
                  <IconButton
                    onClick={handleMobileDrawerToggle}
                    edge="start"
                    sx={{
                      ...(mobileDrawerOpen && { display: "none" }),
                    }}
                    className={classes.topbarButton}
                  >
                    {mobileDrawerOpen ? (
                      <CloseIcon className={classes.topbarIcon} />
                    ) : (
                      <MenuIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </Grid>
                <Grid item md={2} sm={2}>
                  <Typography width={"100%"} className={classes.h4}>
                    {topBarTitle}
                  </Typography>
                </Grid>
                <Grid item md={9} sm={9} justifyContent="end" alignItems="end">
                  <Grid
                    container
                    spacing={1}
                    alignItems="end"
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Grid item>
                      <IconButton
                        onClick={handleClickNotificationPopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                      >
                        <MdOutlineNotificationsNone
                          className={classes.topbarIcon}
                        />
                      </IconButton>
                      <IconButton
                        onClick={toggleTheme}
                        aria-haspopup="true"
                        className={classes.topbarButton}
                      >
                        {mode == "light" ? (
                          <MdDarkMode className={classes.topbarIcon} />
                        ) : (
                          <MdDarkMode className={classes.topbarIcon} />
                        )}
                      </IconButton>
                      <IconButton
                        onClick={handleClickProfilePopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                      >
                        <Avatar
                          alt="Travis Howard"
                          src={UserImg}
                          className={classes.topbarIconProfile}
                        />
                      </IconButton>
                    </Grid>

                    <Box mb={0.5}>
            <Typography
        className={classes.h5}
              sx={{ fontWeight: 500,color: "text.secondary", lineHeight: 1.1 }}
              noWrap
            >
              {userInfo?.username}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontSize: "0.75rem" }}
              noWrap
            >
              {userInfo?.role}  
            </Typography>
          </Box>
        

                    <Grid item>
                      <div className={classes.appSearch}>
                        <Typography className={classes.h5} noWrap>
                          {userInfo?.username}
                        </Typography>
                        <span style={{ fontSize: "0.8rem", color: "#888" }}>
                          {userInfo?.role}
                        </span>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Profile
                profile={profilePopUp}
                onClose={handleCloseProfilePopUp}
                open={openProfilePopUp}
              />
              <Notification
                notification={notificationPopUp}
                onClose={handleCloseNotificationPopUp}
                open={openNotificationPopUp}
              />
            </Toolbar>

            <>
              <MobileDrawer
                open={mobileDrawerOpen}
                onClose={handleMobileDrawerClose}
               
              >
                <DrawerHeader>
                  {open && (
                    <img
                      src={LogoMain}
                      alt="AttoDesk Login"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        cursor: "pointer",
                        maxWidth:"70px",
                        marginRight:"140px"
                
                      }}
                      onClick={handleImgClick}
                    />
                  )}
                  <IconButton
                    className={classes.topbarButton}
                    onClick={handleMobileDrawerClose}
                  >
                    {theme.direction === "rtl" ? (
                      <ChevronRightIcon className={classes.topbarIcon} />
                    ) : (
                      <ChevronLeftIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </DrawerHeader>
                <DrawerContent>
                  {filteredMainMenuList.map((ml, index) => (
                    <React.Fragment key={index}>
                      <Box>
                        {open && (
                          <Typography className={classes.menuTitle}>
                            {ml.comomTitle}
                          </Typography>
                        )}
                      </Box>
                      {ml.menuList && (
                        <List>
                          {ml.menuList.map((menuList) => (
                            <ListItem
                              button
                              key={menuList.title}
                              disablePadding
                              sx={{
                                display: "block",
                              }}
                              onMouseEnter={() =>
                                setHoveredMenuName(menuList.path)
                              }
                              onMouseLeave={() => setHoveredMenuName("")}
                            >
                              <ListItemButton
                                component={Link}  to={menuList.path}
                                onClick={() =>
                                  handleMainMenuItemClick(menuList)
                                }
                                sx={{
                                  transition: "none",
                                  "&:hover": {
                                    transition: "none",
                                    "& .MuiListItemIcon-root, & .MuiTypography-root":
                                      {
                                        color:
                                          theme.palette.mainMenuNav
                                            .hoverColorNavBg,
                                        transition: "none",
                                      },
                                  },
                                  "& .MuiListItemIcon-root": {
                                    color:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? "#0d1b2a"
                                        : currentMenuName === menuList.path
                                        ? "#475569"
                                        : "#475569",
                                    opacity:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? 1
                                        : 0.6,
                                    transition: "none",
                                  },
                                  "& .MuiTypography-root": {
                                    color:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? theme.palette.mainMenuNav
                                            .hoverColorNavBg
                                        : currentMenuName === menuList.path
                                        ? theme.palette.mainMenuNav
                                            .hoverColorNavBg
                                        : theme.palette.mainMenuNav
                                            .hoverColorNavBg,
                                    opacity:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? 1
                                        : 0.6,
                                    transition: "none",
                                  },
                                  borderLeft:
                                    selectedSubmenu?.startsWith(
                                      menuList.path
                                    ) || currentMenuName === menuList.path
                                      ? "3px solid #c9a96e"
                                      : currentMenuName === menuList.path
                                      ? "none"
                                      : "none",
                                }}
                              >
                                <ListItemIcon
                                  className={classes.listItemIcomMainMenu}
                                >
                                  {menuList.icon as React.ReactNode}
                                </ListItemIcon>
                                <ListItemText>{menuList.title}</ListItemText>
                                <ListItemIcon
                                  className={classes.listItemIcomMainMenu}
                                  sx={{
                                    display: "flex",
                                    textAlign: "end",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {menuList.submenus &&
                                    (expandMenu === menuList.title ? (
                                      <ExpandLessIcon
                                        sx={{
                                          fontSize: "18px",
                                          display: "flex",
                                          textAlign: "end",
                                          justifyContent: "flex-end",
                                          "&:hover": {
                                            color:
                                              theme.palette.mainMenuNav
                                                .hoverColorNavBg,
                                          },
                                          color:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : currentMenuName ===
                                                menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : theme.palette.mainMenuNav
                                                  .hoverColorNavBg,
                                          opacity:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? 1
                                              : 0.6,
                                        }}
                                      />
                                    ) : (
                                      <ExpandMoreIcon
                                        sx={{
                                          fontSize: "18px",
                                          display: "flex",
                                          textAlign: "end",
                                          justifyContent: "flex-end",
                                          "&:hover": {
                                            color:
                                              theme.palette.mainMenuNav
                                                .hoverColorNavBg,
                                          },
                                          color:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : currentMenuName ===
                                                menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : theme.palette.mainMenuNav
                                                  .hoverColorNavBg,
                                          opacity:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? 1
                                              : 0.6,
                                        }}
                                      />
                                    ))}
                                </ListItemIcon>
                              </ListItemButton>
                              {menuList.submenus && (
                                <Collapse
                                  in={expandMenu === menuList.title}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <List>
                                    {menuList.submenus.map((submenu) => (
                                      <ListItem
                                        disablePadding
                                        key={submenu.title}
                                        onMouseEnter={() =>
                                          setHoveredSubmenu(submenu.path)
                                        }
                                        onMouseLeave={() =>
                                          setHoveredSubmenu("")
                                        }
                                      >
                                        <ListItemButton
                                          component={Link} to={submenu.path}
                                          onClick={() =>
                                            handleSubmenuItemClicked(submenu)
                                          }
                                          sx={{
                                            pl: "72px",
                                            "&:hover": {
                                              "& .MuiListItemIcon-root, & .MuiTypography-root":
                                                {
                                                  color:
                                                    theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                                },
                                            },
                                            "& .MuiTypography-root": {
                                              color:
                                                hoveredSubmenu ===
                                                  submenu.path ||
                                                currentMenuName === submenu.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                              opacity:
                                                hoveredSubmenu ===
                                                  submenu.path ||
                                                currentMenuName === submenu.path
                                                  ? 1
                                                  : 0.6,
                                            },
                                          }}
                                        >
                                          <ListItemText>
                                            <Typography>
                                              {submenu.title}
                                            </Typography>
                                          </ListItemText>
                                        </ListItemButton>
                                      </ListItem>
                                    ))}
                                  </List>
                                </Collapse>
                              )}
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </React.Fragment>
                  ))}
                </DrawerContent>
              </MobileDrawer>
            </>
          </AppBar>
        </Box>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 },
          width: isMobile ? "100%" : open ? `calc(100% - ${drawerWidth}px)` : "100%",
          minWidth: 0,
          overflowX: "clip",
        }}
      >
        <PaddingBody />
        {children}
      </Box>
    </Box>
  );
}
